const ORDERS_AUTH_OTP = {
  dataAid: "enterOtp",
  navigationHeader: {
    dataAid: "enterOtp",
    title: {
      text: "Enter OTP",
      dataAid: "We’ve sent the OTP to your registered mobile number and email",
    },
    subtitle: {
      text: "We’ve sent the OTP to your registered mobile number and email",
      dataAid: "subtitle",
    },
  },
  otp: {
    infoText: "Didn't receive OTP? Resend in",
    dataAid: "default",
    retryInfoText: "Didn't receive OTP?",
    buttonText: "Resend",
  },
  switch: {
    cta: "Confirm switch",
  },
  redeem: {
    cta: "Confirm order",
  },
  swp: {
    cta: "Confirm order",
  },
  stp: {
    cta: "Confirm switch",
  },
};

export default ORDERS_AUTH_OTP;
